export const defaultParamsList = {
    firebase:{
    "user_id": {
        "name": "user_id",
        "status": "inactive"
    },
    "action_time": {
        "name": "actionTime",
        "status": "inactive"
    },
    "outlet_code": {
        "name": "outlet_code",
        "status": "inactive"
    },
    "outlet_class": {
        "name": "outlet_class",
        "status": "inactive"
    },
    "outlet_channel": {
        "name": "outlet_channel",
        "status": "inactive"
    },
    "device_unique_id": {
        "name": "device_unique_id",
        "status": "inactive"
    }
},
moengage:{
    "user_id": {
        "name": "user_id",
        "status": "inactive"
    },
    "action_time": {
        "name": "actionTime",
        "status": "inactive"
    },
    "outlet_code": {
        "name": "outlet_code",
        "status": "inactive"
    },
    "outlet_class": {
        "name": "outlet_class",
        "status": "inactive"
    },
    "outlet_channel": {
        "name": "outlet_channel",
        "status": "inactive"
    },
    "device_unique_id": {
        "name": "device_unique_id",
        "status": "inactive"
    }
},
database:{
    "user_id": {
        "name": "user_id",
        "status": "inactive"
    },
    "action_time": {
        "name": "actionTime",
        "status": "inactive"
    },
    "outlet_code": {
        "name": "outlet_code",
        "status": "inactive"
    },
    "outlet_class": {
        "name": "outlet_class",
        "status": "inactive"
    },
    "outlet_channel": {
        "name": "outlet_channel",
        "status": "inactive"
    },
    "device_unique_id": {
        "name": "device_unique_id",
        "status": "inactive"
    }
}
}